@if (cartovistaParameters && cartovistaParameters.areApiKeysSet) {
  <div id="cartovista-div">
    <iframe #cartovista id="cartovista" [src]="cartovistaPanelContent" [title]="'TITLE.CARTOVISTA' | translate"></iframe>
  </div>
} @else if (cartovistaParameters && !cartovistaParameters.areApiKeysSet) {
  <div id="no-cartovista-configuration-container" class="fx-layout-col fx-justify-center fx-align-center fx-gap-25">
    <mat-icon fontSet="material-icons" fontIcon="warning" id="warning-icon"></mat-icon>
    <h4 id="no-cartovista-configuration-message">
      {{ "LABEL.NO_CARTOVISTA_CONFIGURATION" | translate }}
    </h4>
  </div>
} @else {
  <spinner></spinner>
}
